import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_SUFFIX = "Dr. Hoffmann-Prinzip";

const ROUTE_TITLES = {
  "/": `Startseite · ${SITE_SUFFIX}`,
  "/karriere": "Karriere bei Dr. Hoffmann - Wir stellen ein",
  "/impressum": `Impressum · ${SITE_SUFFIX}`,
  "/datenschutz": `Datenschutz · ${SITE_SUFFIX}`,
  "/einloggen": `Einloggen · ${SITE_SUFFIX}`,
  "/registrieren": `Registrieren · ${SITE_SUFFIX}`,
  "/auth/verifizieren": `E-Mail bestätigen · ${SITE_SUFFIX}`,
  "/auth/passwort-vergessen": `Passwort vergessen · ${SITE_SUFFIX}`,
  "/auth/passwort-zuruecksetzen": `Passwort zurücksetzen · ${SITE_SUFFIX}`,
  "/auth/konto-loeschen": `Konto löschen · ${SITE_SUFFIX}`,
  "/buchen": `Buchen · ${SITE_SUFFIX}`,
  "/buchen/erfolg": `Buchung bestätigt · ${SITE_SUFFIX}`,
  "/konto": `Mein Konto · ${SITE_SUFFIX}`,
  "/admin-dashboard": `Team-Dashboard · ${SITE_SUFFIX}`,
  "/qr-code": `QR-Registrierung · ${SITE_SUFFIX}`,
  "/leonardo-nikolai": "Leonardo-Nikolai Hotelservice - Dr. Hoffmann Massagen",
  "/leonardo-nyx": "NYX Hotels by Leonardo Hotels - Dr. Hoffmann Massagen",
};

const DEFAULT_TITLE =
  "Dr. Hoffmann-Prinzip — Schnell. Smart. Skalierbar. · MediConsult GmbH";

const ROUTE_DESCRIPTIONS = {
  "/karriere":
    "Dr. Hoffmann sucht Fachkräfte, Mitarbeiter und Lizenznehmer. Bewerben Sie sich für Minijob, Teilzeit, Festanstellung oder als Partner im modernen Gesundheitskonzept.",
};

const DEFAULT_DESCRIPTION =
  "Dr. Hoffmann-Prinzip: schnell, smart und skalierbar. Moderne Gesundheitsangebote und Buchungen der MediConsult GmbH.";

function titleForPath(pathname) {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  if (/^\/konto\/buchungen\/[^/]+\/aendern$/.test(pathname)) {
    return `Termin ändern · ${SITE_SUFFIX}`;
  }
  return DEFAULT_TITLE;
}

function trackPageView(pagePath, title) {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_title: title,
    page_location: window.location.href,
  });
}

function setMetaDescription(description) {
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", description);
}

export default function AnalyticsPageView() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const pagePath = `${pathname}${search}${hash}`;
    const title = titleForPath(pathname);
    const description = ROUTE_DESCRIPTIONS[pathname] || DEFAULT_DESCRIPTION;

    document.title = title;
    setMetaDescription(description);
    trackPageView(pagePath, title);
  }, [pathname, search, hash]);

  return null;
}
